import { useState } from "react";

import { Box } from "@/Components/v2/atoms/Box";
import { Button } from "@/Components/v2/atoms/Button";
import Container from "@/Components/v2/atoms/Container/Container";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";
import SlickCarousel from "@/Components/v2/molecule/SlickCarousel/SlickCarousel";
import { useAnalytics } from "@/hooks/useAnalytics";

import { maiteSuggestedPrompts } from "../constants/content";
// Import the background image
import rippleOptimisedBg from "../images/Ripple-optimised.jpg";
import { UnlockMaiteModal } from "./UnlockMaiteModal";

export const MaitePromoWidget = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { buttonClicked } = useAnalytics();

  const handleLearnMore = () => {
    buttonClicked({
      buttonName: "Learn More",
      buttonLocation: "Growth Center - MAITE Promo Widget",
      buttonType: "modal",
    });

    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Box
      sx={{
        borderRadius: 3,
        background: `url(${rippleOptimisedBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
        overflow: "hidden",
        px: 4,
        py: "60px",
        mb: 3,
      }}
    >
      <Stack
        spacing={3}
        justifyContent="center"
        alignItems="center"
        sx={{ position: "relative", zIndex: 1 }}
      >
        {/* Descriptive text */}
        <Typography
          variant="h6"
          component="p"
          sx={{
            color: "white",
            textAlign: "center",
            fontWeight: 600,
            lineHeight: 1.5,

            mx: "auto",
          }}
        >
          MAITE is your growth co-pilot, designed to help you unlock better growth decisions at
          scale.
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            p: 3,
            width: "70%",
            border: "1px solid #E7E7E7",
            borderRadius: 2,
            background: "rgba(255, 255, 255, 0.30)",
          }}
        >
          <Container>
            <SlickCarousel
              vertical={true}
              autoplay={true}
              autoplaySpeed={2000}
              dots={false}
              arrows={false}
            >
              {maiteSuggestedPrompts.map((item) => (
                <Typography
                  key={item}
                  variant="body2"
                  fontSize="0.875rem"
                  textAlign="center"
                  sx={{ color: "white" }}
                >
                  {item}
                </Typography>
              ))}
            </SlickCarousel>
          </Container>
        </Box>

        <Button
          sx={{ backgroundColor: "white", borderRadius: 5, px: 2, py: 1 }}
          onClick={handleLearnMore}
        >
          <Typography
            variant="body2"
            sx={{ color: "black", textTransform: "none" }}
            fontWeight={500}
          >
            Learn More
          </Typography>
        </Button>
      </Stack>

      <UnlockMaiteModal open={isModalOpen} onClose={handleCloseModal} />
    </Box>
  );
};
